import {
	ExceptionDTO,
	ReportingUnitStat,
	Unit,
	UnitCount,
} from '../../../models';
import { HttpResponse } from '../apiTemplate';
import ApiService from '../apiTemplate/api';

class UnitService extends ApiService {
	constructor() {
		super();
		this.credentials = 'include';
		this.redirect = 'follow';
		this.setHeaders([
			{
				key: 'Accept',
				value: 'application/json',
			},
			{
				key: 'ContentType',
				value: 'application/json',
			},
		]);
	}

	/**
	 * get unit
	 */
	public async getUnit(
		line: string,
		stationId: number,
		sequence: number
	): Promise<HttpResponse> {
		this.setMethod('GET');
		try {
			const res = await fetch(
				`${this.endPoint}/v1/unit/station/${stationId}/line/${line}/seq/${sequence}`,
				this.request()
			);
			const data = await res.json();
			const isOffline = res.status >= 500;

			return res.ok
				? { message: data, ok: true }
				: {
						isOffline,
						message: isOffline
							? 'offline'
							: ((await res.json()) as ExceptionDTO),
						ok: false,
				  };
		} catch {
			// Network or parsing error: treat as offline and return a safe fallback
			// rather than propagating the exception to the caller.
			console.error('failed retrieve unit information');
			return {
				isOffline: true,
				message: 'offline',
				ok: false,
			};
		}
	}

	/**
	 * get units from station
	 * @param stationId
	 * @param line
	 * @param stationId
	 * @param passage
	 * @returns
	 */
	public async getUnitsFromStationId(
		stationId: number,
		line: string,
		passage: number
	): Promise<Array<Unit>> {
		this.setMethod('GET');
		try {
			const res = await fetch(
				`${this.endPoint}/v1/unit/station/${stationId}/line/${line}?passage=${passage}`,
				this.request()
			);
			const data = await res.json();

			return data as Unit[];
		} catch (error) {
			throw new Error(`failed retrieve unit information: ${String(error)}`);
		}
	}

	/**
	 * get
	 */
	public async getCountUnits(line?: string): Promise<UnitCount> {
		this.setMethod('GET');
		try {
			const res = await fetch(
				`${this.endPoint}/v1/unit/count/line/${line}`,
				this.request()
			);
			const unitCounts = await res.json();
			return {
				normalUnitCount: Number(unitCounts.normalUnitCount),
				spTerminusUnitCount: Number(unitCounts.spTerminusUnitCount),
				spUnitCount: Number(unitCounts.spUnitCount),
				terminusUnitCount: Number(unitCounts.terminusUnitCount),
			};
		} catch (error) {
			throw new Error(`failed to get lines list: ${String(error)}`);
		}
	}

	/**
	 * get
	 */
	public async getUnitStats(
		beginDate: Date,
		endDate: Date,
		line?: string
	): Promise<ReportingUnitStat> {
		this.setMethod('GET');
		try {
			const res = await fetch(
				`${
					this.endPoint
				}/v1/unit/stat/line/${line}?beginDate=${beginDate.toISOString()}&endDate=${endDate.toISOString()}`,
				this.request()
			);
			return (await res.json()) as ReportingUnitStat;
		} catch (error) {
			throw new Error(`failed to get units list: ${String(error)}`);
		}
	}
}

export const unitService = new UnitService();
